import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { EmptyStateComponent } from "@/components/shared/empty-state/empty-state.component";

@Component({
    selector: "app-not-allowed",
    templateUrl: "./not-allowed.component.html",
    styleUrls: ["./not-allowed.component.scss"],
    standalone: true,
    imports: [RouterModule, EmptyStateComponent],
})
export class NotAllowedComponent {}
